const FNV_OFFSET_BASIS_32 = 0x811c9dc5;
const FNV_PRIME_32 = 0x01000193;

/**
 * 32-bit FNV-1a hash of a string, as 8 lowercase hex characters.
 *
 * Fast, synchronous and non-cryptographic: use it to derive a stable,
 * non-reversible identifier (for example a storage key or cache key) from a
 * value you do not want to store in plain text. Do not use it where collision
 * resistance matters.
 */
export function fnv1a32(input: string): string {
  let hash = FNV_OFFSET_BASIS_32;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME_32);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
}
